import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';
const compareObjects = require('fast-deep-equal');

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { ProgressBar } from './ProgressBar';
import SelectField from '../ts/SelectField';
import StringField from '../ts/StringField';
import { validators } from '../../../_common/platform/ts/validators';
import { AttrValueColorSelect } from './AttrValueColorSelect';
import { IValuesCollection } from '../ts/appTheme';

import {
    DataloadEventTypes,
    IDataLoadEntity,
    EntityModelsStore
} from '../../../pdc-platform/src/ts/stores/EntityModelsStore';

import FormEditMixin, {
    IFormEditMixinComponentProperties,
    IFormEditMixinComponentOptions
} from './mixins/FormEditMixin';

import { ATTRIBUTE_TYPES } from '../ts/ConfigurationConstants';

function getDataSourceField(
    entityModelsStore: EntityModelsStore,
    isEdit: boolean,
    entitiesList: IDataLoadEntity[],
    keys,
    dataSourceID: number
) {
    const stateDataSources = entityModelsStore.getDataSources();

    let entityNameControl, selectDSControl;
    let dsValues = [];
    let dsDisplay = [];

    if (stateDataSources.length > 1) {
        dsValues = _.pluck(stateDataSources, 'dataSourceID');
        dsDisplay = _.pluck(stateDataSources, 'name');
    }

    if (isEdit === false) {
        // ADD NEW mode
        let listEntities = [];

        _.map(entitiesList, (entity) => {
            _.map(entity.attributes, (attr) => {
                if (attr.type === ATTRIBUTE_TYPES.STRING) {
                    if (attr.name === entity.DefaultAttribute) {
                        let dsEntityName = entity.name + '→' + dataSourceID;

                        if (keys[dsEntityName] == undefined) {
                            listEntities.push(entity.name);
                        }
                    } else {
                        let dsEntityName = entity.name + '.' + attr.name + '→' + dataSourceID;

                        if (keys[dsEntityName] == undefined) {
                            listEntities.push(entity.name + '.' + attr.name);
                        }
                    }
                }
            });
        });

        listEntities = _.compact(listEntities);
        listEntities.unshift('');
        listEntities.sort(); //??DO NOT SORT this table, rest the sorting of Leo, got from backend!!!

        entityNameControl = new SelectField(this.props.glob, 'Entity', [validators.string.notEmpty], null, {
            values: listEntities,
            display: listEntities
        });

        selectDSControl = new SelectField(this.props.glob, 'Data Source', [], '', {
            values: dsValues,
            display: dsDisplay,
            onChange: handleDataSourceChange(entityModelsStore)
        });
    } else {
        // EDIT EXISTED mode
        entityNameControl = new StringField(this.props.glob, 'Entity', [validators.string.notEmpty], '', {
            readOnly: true
        });
        selectDSControl = new StringField(this.props.glob, 'Data Source', [validators.string.notEmpty], '', {
            readOnly: true
        });
    }

    return {
        selectDS: selectDSControl,
        entityName: entityNameControl
    };
}

function handleDataSourceChange(attrQueryStore: EntityModelsStore) {
    return function (obj) {
        if (obj != null && obj.selectDS != null) {
            let dsId = parseInt(obj.selectDS);

            attrQueryStore.storeDataSourceID(dsId);
        }
    };
}

//LL: 07.09.20: add dataSourceID
function checkEntityAssigned(assignedKeys: string[], entityName: string, dataSourceID, entities: IDataLoadEntity[]) {
    //const assignedAttributes = _.map(assignedKeys, (key) => {
    //    let toks = key.split('→');
    //    return toks[0] || '';
    //});
    //LL: 07.09.20:
    const assignedAttributes = _.map(assignedKeys, (key) => {
        let toks = key.split('→'); //  arr ["customer", "2"]
        return { entity: toks[0] || '', ds: toks[1] || 0 }; //LL: ds is string here
    });

    const entity = _.find(entities, (e) => {
        return e.name === entityName;
    });

    const entityWithDefaultAttr =
        entity && entity.DefaultAttribute !== '' ? entity.name + '.' + entity.DefaultAttribute : '';

    //const alreadyAssigned = _.find(assignedAttributes, (attr) => {
    //    return attr === entityName || attr === entityWithDefaultAttr;
    //});
    //LL: 07.09.20:
    const alreadyAssigned = _.find(assignedAttributes, (attr) => {
        return (
            (attr.entity === entityName || attr.entity === entityWithDefaultAttr) && attr.ds === dataSourceID.toString()
        );
    });

    return alreadyAssigned != null;
}

interface IEditEntityColorMapOptions extends IFormEditMixinComponentOptions {
    themeObj?;

    entityName: string;
    dataSourceID: number;
    dataSourceName: string;
    edit;
    colorMappingOfEntity;
    keys;

    parentColors?; //LL: 10.10.20: parentColors
    parentValues?; //LL: 10.10.20: parentValues

    onChange?(value, newColorMapping): void;
}

interface IEditEntityColorMapProperties extends IFormEditMixinComponentProperties<IEditEntityColorMapOptions> {
    onChange(value, newColorMapping): void;
    setConfirmValueGetter(getConfirmValue);
    unsetConfirmValueGetter?();

    glob: IGlob;
}

const GET_KEY_ATTRIBUTE_FOR_VALUES = true;

//LL: 10.10.20: parentValues
//LL: 10.10.20: parentColors
class EditEntityColorMap extends React.Component<
    IEditEntityColorMapProperties,
    {
        value;
        colorMappingOfEntity;
    }
> {
    private formEditMixin: FormEditMixin<IEditEntityColorMapProperties, IEditEntityColorMapOptions> = null;

    private getConfirmValue = () => {
        return this.state.value;
    };

    constructor(props) {
        super(props);

        this.formEditMixin = new FormEditMixin(this);

        //LL: 10.10.20: parentColors
        //let parentColors = this.props.options.parentColors;  //  ~~ { <no value>: "#dddddd", S20: "d50000" ]
        //LL: 10.10.20: parentValues
        //let parentValues = this.props.options.parentValues;  // when add

        this.state = {
            value: {
                entityName: this.props.options.entityName,
                selectDS: this.props.options.dataSourceID,
                dsName: this.props.options.dataSourceName
            },
            colorMappingOfEntity: this.props.options.colorMappingOfEntity //LL: 03.12.19
        };

        //LL: 28.02.25: was in componentWillMount
        let obj = this.props.setConfirmValueGetter(this.getConfirmValue);
    }

    _onChangeColor = (newColorMapping) => {
        if (this.props.options != null && typeof this.props.options.onChange === 'function') {
            this.props.options.onChange(this.state.value, newColorMapping);
        }

        this.setState({ colorMappingOfEntity: newColorMapping }); //LL: 03.12.19
    };

    handleOnStoreChange = () => {
        this.setState(this.state);
    };

    componentDidMount() {
        this.props.glob.EntityModelsStore.addChangeListener(this.handleOnStoreChange);
    }

    componentWillUnmount() {
        this.props.glob.EntityModelsStore.removeChangeListener(this.handleOnStoreChange);

        if (typeof this.props.unsetConfirmValueGetter === 'function') {
            this.props.unsetConfirmValueGetter();
        }
    }

    render() {
        let divDataSourceCombo; // data source combo-box
        let dataSourceID = this.props.glob.EntityModelsStore.getStoredDataSourceID();

        if (this.state.value.selectDS != undefined) {
            dataSourceID = parseInt(this.state.value.selectDS);
        }

        const entities: IDataLoadEntity[] = this.props.glob.EntityModelsStore.getEntitiesByDS(dataSourceID);

        const dataSourceField = getDataSourceField.call(
            this,
            this.props.glob.EntityModelsStore,
            this.props.options.edit,
            entities,
            this.props.options.keys,
            dataSourceID
        );

        if (this.props.glob.EntityModelsStore.getDataSources().length > 1) {
            if (this.props.options.edit) {
                divDataSourceCombo = (
                    <div className="data-source-control">
                        {this.formEditMixin.getField(dataSourceField.selectDS, 'dsName')}
                    </div>
                );
            } else {
                divDataSourceCombo = (
                    <div className="data-source-control">
                        {this.formEditMixin.getField(dataSourceField.selectDS, 'selectDS')}
                    </div>
                );
            }
        }

        let sqlTableField = (
            <div className="row widget-parameters-edit">
                <div className="col-sm-6">{this.formEditMixin.getField(dataSourceField.entityName, 'entityName')}</div>
            </div>
        );

        let attrValueColorSelect_Elem: React.JSX.Element;

        //LL: 07.09.20: add dataSourceID
        let error = checkEntityAssigned(
            _.keys(this.props.options.keys),
            this.state.value.entityName,
            dataSourceID, //LL: 07.09.20
            entities
        );

        if (error) {
            attrValueColorSelect_Elem = (
                <div className="text-danger">
                    {'The entity ' +
                        this.state.value.entityName +
                        ' or its default attribute already has Color Mapping assigned.'}
                </div>
            );
        } else {
            //LL: 10.10.20: parentColors   is defined when this.props.options.edit is true:
            let parentColors = this.props.options.parentColors; //  ~~ { <no value>: "#dddddd", S20: "d50000" ]

            //LL: 10.10.20: parentValues
            //LL: But parentColors will be always empty when "add",
            //       because "parent" mappings are already added as inherited and their "ds/attr" are excluded
            if (this.props.options.edit === false) {
                parentColors = {};
                let parentValues = this.props.options.parentValues; // when add
                if (parentValues != null) {
                    for (let k = 0; k < parentValues.length; k++) {
                        const pv = parentValues[k];
                        if (pv.dataSourceID === dataSourceID && pv.attribute === this.state.value.entityName) {
                            parentColors = pv.colorMap;
                            break;
                        }
                    }
                }
            }

            attrValueColorSelect_Elem = (
                <AttrValueColorSelect
                    glob={this.props.glob}
                    themeObj={this.props.options.themeObj}
                    attrColorMapping={this.state.colorMappingOfEntity}
                    attribute={this.state.value.entityName}
                    dataSourceID={dataSourceID}
                    parentColors={parentColors}
                    onChange={this._onChangeColor}
                />
            );
        }

        return (
            <div>
                <div>
                    {divDataSourceCombo}
                    {sqlTableField}
                </div>
                {attrValueColorSelect_Elem}
            </div>
        );
    }
}

interface IColorMappings {
    [key: string]: any;
}

interface IEntityColorSelectState {
    colorMapping: IColorMappings;
    ownAndParent;

    entityVal: {
        dsEntityName: string;
        colorMapping;
    };
}

export class EntityColorSelect extends React.Component<
    {
        value;
        theme?: IValuesCollection;

        themeObj?; //LL: 08.11.19

        options: {
            optionThemeOwnAndParent;
            theme?: IValuesCollection;

            onChange?(newValues): void;
        };

        onChange?(newValues): void;

        glob: IGlob;
    },
    IEntityColorSelectState
> {
    //LL: 11.10.20:  move here from commonTheme.ts
    //LL: was, not my  //LL: 09.10.20: this merger is similar to appTheme.mergerForArrays
    public static themeMerger(src, obj) {
        //LL:  src - upper,  obj - own  or src - already exist,  obj - own new

        //LL: 09.10.20:
        if (src == null) {
            src = [];
        }

        //src = _.clone(src);  //LL: was shallow copy
        //LL: 09.10.20: make copy
        let src2 = _.map(src, (item) => {
            let a: any = $.extend(true, {}, item);
            return a;
        });
        let obj2 = _.map(obj, (item) => {
            let a: any = $.extend(true, {}, item);
            return a;
        });

        //===============================================
        //// remove all color definitions from SRC for attribute that are redefined in OBJ
        //let src_1 = _.reject(
        //    //src,
        //    src2,  //LL: 09.10.20
        //    (src_item: any) => {
        //        return (
        //            _.find(
        //                //obj,
        //                obj2, //LL: 09.10.20
        //                (obj_item: any) => {
        //                    //return (obj_item.attribute === src_item.attribute)
        //                    return ((obj_item.attribute === src_item.attribute) && (obj_item.dataSourceID === src_item.dataSourceID)); //LL: 09.10.20
        //                }
        //            ) != null
        //        )
        //    }
        //)
        //
        ////LL: 09.10.20: set "inherited" to remained SRC:
        //_.each(src_1, (item) => {
        //    item.inherited = true;  // new
        //});
        //
        //// Concat remainders
        ////return src_1.concat(obj);
        //return src_1.concat(obj2);  //LL: 09.10.20
        //===============================================

        //LL: 09.10.20: try another method: extend values:  OBJ overrides SRC
        //       item.inherited = true; ?
        _.each(obj2, (obj_item: any) => {
            let fnd_src_item = _.find(src2, (src_item: any) => {
                return obj_item.attribute === src_item.attribute && obj_item.dataSourceID === src_item.dataSourceID; //LL: 09.10.20
            });
            if (fnd_src_item != null) {
                $.extend(true, fnd_src_item, obj_item);
                //LL: 10.10.20: try to set inherited flag to color items:
                //let src_colorMap = fnd_src_item.colorMap;
                //let obj_colorMap = obj_item.colorMap;
                //// color in src_colorMap and not in obj_colorMap => inherited
                ////  _.filter(list, predicate, [context])
                ////  let evens = _.filter([1, 2, 3, 4, 5, 6], function(num){ return num % 2 == 0; });
                //let arr = _.filter(src_colorMap, function(item, key: any) {
                //    return !(_.has(obj_colorMap, key));
                //});
                //let r = arr;
            } else {
                src2.push(obj_item); // it is copy already
            }
        });
        return src2;
    }

    constructor(props) {
        super(props);

        let myValue = this.props.value;
        let newValues: IColorMappings = {};
        let isReady = false;

        _.each(myValue, (itemOne: any, key) => {
            if (itemOne.attribute != undefined && itemOne.dataSourceID != undefined) {
                isReady = true;
                const newKey = itemOne.attribute + '→' + itemOne.dataSourceID.toString();
                newValues[newKey] = itemOne.colorMap;
            }
        });

        if (!isReady) {
            _.each(myValue, (val, key: any) => {
                if (key.indexOf('→') > 0) {
                    newValues[key] = val;
                } else {
                    let newKey = key + '→1';
                    newValues[newKey] = val;
                }
            });
        }

        //LL: 06.06.18:
        let optionThemeOwnAndParent = {};
        if (this.props.options != null && this.props.options.optionThemeOwnAndParent != null) {
            optionThemeOwnAndParent = this.props.options.optionThemeOwnAndParent;
        }

        this.state = {
            colorMapping: newValues,
            ownAndParent: optionThemeOwnAndParent, //LL: 06.06.18
            entityVal: {
                dsEntityName: '', //new format: Name + -> + dsID
                colorMapping: {}
            }
        };
    }

    componentDidMount() {
        this.props.glob.EntityModelsActions.loadModels();
        this.props.glob.EntityModelsStore.addOnDataLoadListener(this.handleOnEntityModelsChange);
    }

    componentWillUnmount() {
        this.props.glob.EntityModelsStore.removeOnDataLoadListener(this.handleOnEntityModelsChange);
    }

    handleOnEntityModelsChange = (eventType: DataloadEventTypes) => {
        if (eventType === DataloadEventTypes.MODEL) {
            this.setState(this.state);
        }
    };

    componentWillReceiveProps(nextProps) {
        let myValue = nextProps.value;
        let newValues = {};
        let isReady = false;

        //if (_.isArray(myValue)) {
        _.each(myValue, (itemOne: any, key) => {
            if (itemOne.attribute != undefined && itemOne.dataSourceID != undefined) {
                isReady = true;
                let newKey = itemOne.attribute + '→' + itemOne.dataSourceID.toString();
                newValues[newKey] = itemOne.colorMap;
            }
        });

        if (!isReady) {
            _.each(myValue, (val, key: any) => {
                if (key.indexOf('→') > 0) {
                    newValues[key] = val;
                } else {
                    let newKey = key + '→1';
                    newValues[newKey] = val;
                }
            });
        }

        //LL: 06.06.18:
        let optionThemeOwnAndParent = {};
        if (nextProps.options != null && nextProps.options.optionThemeOwnAndParent != null) {
            optionThemeOwnAndParent = nextProps.options.optionThemeOwnAndParent;
        }

        this.setState({
            colorMapping: newValues,
            ownAndParent: optionThemeOwnAndParent //LL: 06.06.18
        });
    }

    handleEntityColorChange = (entity, newColorMapping) => {
        //entity.entityName, entity.selectDS
        let entityVal = {
            dsEntityName: entity.entityName + '→' + entity.selectDS, //new format: Name + '→' + dsID
            colorMapping: newColorMapping
        };
        //entity.colorMapping = newColorMapping;
        this.setState({ entityVal: entityVal });
    };

    passChange = (value) => {
        let newValues = [];

        //LL: 28.08.20: to check if item is equal with parent item, don't save such items
        let parentValues = [];
        if (this.state.ownAndParent != null && this.state.ownAndParent.parentValue != null) {
            parentValues = this.state.ownAndParent.parentValue;
        }

        const storedDataSourceID = this.props.glob.EntityModelsStore.getStoredDataSourceID();

        _.each(value, (val, key: any) => {
            let itemOne: any = {};

            if (key.indexOf('→') > 0) {
                let arrayNames = key.split('→');
                let entityName = arrayNames[0];

                let dsID = storedDataSourceID;
                if (arrayNames[1] != undefined) {
                    dsID = arrayNames[1];
                    dsID = parseInt(arrayNames[1]);
                }

                itemOne.dataSourceID = dsID;
                itemOne.attribute = entityName;
                itemOne.colorMap = val;
            } else {
                itemOne.dataSourceID = storedDataSourceID;
                itemOne.attribute = key;
                itemOne.colorMap = val;
            }

            //LL: 28.08.20: to check if item is equal with parent item, don't save such items
            let asParent = false;
            for (let k = 0; k < parentValues.length; k++) {
                const pv = parentValues[k];
                if (pv.dataSourceID === itemOne.dataSourceID && pv.attribute === itemOne.attribute) {
                    if (compareObjects(pv.colorMap, itemOne.colorMap)) {
                        asParent = true;
                    }

                    //LL: 12.10.20: delete "inherited" items:
                    if (!asParent) {
                        let colorMap = itemOne.colorMap;
                        let parent_colorMap = pv.colorMap;
                        let newColors: any = {};
                        _.each(colorMap, function (item, key: any) {
                            if (!(_.has(parent_colorMap, key) && item === parent_colorMap[key])) {
                                newColors[key] = item;
                            }
                        });
                        itemOne.colorMap = newColors;
                    }

                    break;
                }
            }

            //LL:  "if" was commented by me (because of improper Merger?), open it again:
            if (!asParent) {
                newValues.push(itemOne);
            }
        });

        if (newValues.length === 0) {
            newValues = null;
        }

        if (typeof this.props.options.onChange === 'function') {
            this.props.options.onChange(newValues);
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(newValues);
        }
    };

    editEntityColorMapButtonDo = (obj, isAdded: boolean) => {
        const assignedKeys = [];
        _.each(this.props.value, (v: any) => {
            if (v.dataSourceID === obj.selectDS) {
                assignedKeys.push(v.attribute);
            }
        });

        if (isAdded) {
            const entities: IDataLoadEntity[] = this.props.glob.EntityModelsStore.getEntitiesByDS(obj.selectDS);

            //LL: 07.09.20: add dataSourceID
            if (
                checkEntityAssigned(
                    assignedKeys,
                    obj.entityName,
                    obj.selectDS, //LL: 07.09.20
                    entities
                )
            ) {
                return false;
            }
        }

        if (this.state.entityVal.dsEntityName == '') {
            return false;
        }

        let colorMapping = _.clone(this.state.colorMapping);
        colorMapping[this.state.entityVal.dsEntityName] = this.state.entityVal.colorMapping;

        this.setState({
            colorMapping: colorMapping
        });

        this.passChange(colorMapping);

        return true;
    };

    //LL: 07.09.20: add parentColorMap
    removeEntityColor = (dsEntityName, parentColorMap) => {
        let colorMapping = _.clone(this.state.colorMapping);

        //delete colorMapping[dsEntityName];
        //LL: 07.09.20: delete if no parentColorMap, otherwise update by parentColorMap
        if (parentColorMap == null) {
            delete colorMapping[dsEntityName];
        } else {
            colorMapping[dsEntityName] = $.extend(true, {}, parentColorMap);
        }

        let st: any = {
            colorMapping: colorMapping
        };

        //LL: 10.10.20: reset changed colors
        let entityVal: any;
        if (dsEntityName === this.state.entityVal.dsEntityName) {
            entityVal = {
                dsEntityName: dsEntityName,
                colorMapping: null
            };
        }
        if (entityVal != null) {
            st.entityVal = entityVal;
        }

        //this.setState(
        //    {
        //        colorMapping: colorMapping
        //    }
        //);
        this.setState(st);

        this.passChange(colorMapping);
    };

    //LL: 10.10.20: parentValues,  parentColors undef - no ds, no attr
    addEntityColorMapButton = () => {
        let entityVal = {
            dsEntityName: '',
            colorMapping: {}
        };

        this.setState({
            entityVal: entityVal
        });

        //LL: 10.10.20: parentValues
        let parentValues = [];
        if (this.state.ownAndParent != null && this.state.ownAndParent.parentValue != null) {
            parentValues = this.state.ownAndParent.parentValue;
        }

        this.props.glob.DialogActions.createDialog(
            'Add Colors for entity',
            null,
            (obj) => {
                this.editEntityColorMapButtonDo(obj, true);
            },
            function () {},
            function () {},
            'custom',
            {
                deny: false,
                confirmTitle: 'Add',
                Component: EditEntityColorMap,
                componentOptions: {
                    themeObj: this.props.themeObj, //LL: 08.11.19
                    entityName: '',
                    colorMappingOfEntity: {}, //_this.state.colorMapping,
                    keys: this.state.colorMapping,
                    dataSourceID: this.props.glob.EntityModelsStore.getStoredDataSourceID(),
                    parentValues: parentValues, //LL: 10.10.20: parentValues
                    edit: false,
                    onChange: this.handleEntityColorChange
                }
            }
        );
    };

    //LL: 10.10.20: parentColors
    editEntityColorMapButton = (entityName, dsID, dsName, parentColors) => {
        let theme = this.props.theme;
        //if (theme != null && this.props.options != null) {
        if (theme == null && this.props.options != null) {
            //LL: 30.01.20
            theme = this.props.options.theme;
        }
        //LL: 30.01.20:
        if (theme == null) {
            theme = this.props.themeObj;
        }

        this.props.glob.EntityModelsActions.loadEntityValues(dsID, theme, {
            attribute: entityName,
            loadKeyAttribute: GET_KEY_ATTRIBUTE_FOR_VALUES,
            runTimeWidgetID: undefined //EVG: I set it explicitly to show where it should be set when needed.
        });

        let dsEntityName = entityName + '→' + dsID.toString();
        let colorMappingOfEntity = _.extend({}, this.state.colorMapping[dsEntityName], {});

        //LL: 03.12.19: use changed colors
        if (dsEntityName === this.state.entityVal.dsEntityName) {
            let vList = this.state.entityVal.colorMapping;
            if (vList != null) {
                colorMappingOfEntity = _.extend({}, vList);
            }
        }

        let entityVal = {
            dsEntityName: dsEntityName,
            dsID: dsID,
            colorMapping: colorMappingOfEntity
        };

        this.setState({
            entityVal: entityVal
        });

        this.props.glob.DialogActions.createDialog(
            'Edit Colors for entity ',
            null,
            (obj) => {
                this.editEntityColorMapButtonDo(obj, false);
            },
            function () {},
            function () {},
            'custom',
            {
                deny: false,
                confirmTitle: 'Save',
                Component: EditEntityColorMap,
                componentOptions: {
                    themeObj: this.props.themeObj,
                    entityName: entityName,
                    dataSourceID: dsID,
                    dataSourceName: dsName,
                    edit: true,
                    colorMappingOfEntity: colorMappingOfEntity,
                    parentColors: parentColors, //LL: 10.10.20: parentColors
                    onChange: this.handleEntityColorChange
                }
            }
        );
    };

    //LL: 28.08.20: add e.  No changes in behaviour
    removeEntityColorButton = (e, entityName, dsID) => {
        e.stopPropagation();
        e.preventDefault();

        //LL: 31.08.20: to check if item with same (entityName, dsID) is in parent:
        let parentValues = [];
        if (this.state.ownAndParent != null && this.state.ownAndParent.parentValue != null) {
            parentValues = this.state.ownAndParent.parentValue;
        }

        let hasInParent = false;
        let parentColorMap;
        for (let k = 0; k < parentValues.length; k++) {
            const pv = parentValues[k];
            if (pv.dataSourceID === dsID && pv.attribute === entityName) {
                hasInParent = true;
                parentColorMap = pv.colorMap;
                break;
            }
        }

        let parentTxt = '';
        if (hasInParent) {
            parentTxt = ' Inherited value will be used.';
        }
        //  "Color mapping for Entity '" + entityName + "' will be removed. Please, confirm this action.",
        //   \r\n   ?  <br> ? "&#13"
        //  https://stackoverflow.com/questions/9980416/how-can-i-insert-new-line-carriage-returns-into-an-element-textcontent
        //  For new line in textContent You have to use \r\n and, finally,
        //  I had to use css white-space: pre-line; (Text will wrap when necessary, and on line breaks) and everything goes fine.
        //  Or, You can use only white-space: pre; and then text will wrap only on line breaks (in this case \r\n).
        //LL: see class "modal-body" in Dialogs.tsx   Maybe add "white-space: pre-line" ???

        this.props.glob.DialogActions.createDialog(
            'Remove color map: ' + entityName + '',
            "Color mapping for Entity '" +
                entityName +
                "' will be removed." +
                parentTxt +
                ' Please, confirm this action.',
            function () {},
            () => {
                let dsEntityName = entityName + '→' + dsID;
                this.removeEntityColor(dsEntityName, parentColorMap);
            },
            function () {},
            'confirm',
            {
                confirmTitle: null,
                cancelTitle: 'Delete'
            }
        );
    };

    render() {
        const entityModelsStore = this.props.glob.EntityModelsStore;

        if (entityModelsStore._state.loadingDataSources === true) {
            return <ProgressBar />;
        }

        let empty;

        if (_.size(this.state.colorMapping) === 0) {
            empty = (
                <tr key="empty">
                    <td colSpan={5}>
                        <em>{'List of color mapping is empty'}</em>
                    </td>
                </tr>
            );
        }

        //LL: 06.06.18:
        let parentValues = [];
        if (this.state.ownAndParent != null && this.state.ownAndParent.parentValue != null) {
            parentValues = this.state.ownAndParent.parentValue;
        }

        const mouseStyle = { width: '30px', cursor: 'pointer' };
        const dataSources = entityModelsStore.getDataSources();
        const storedDataSourceID = entityModelsStore.getStoredDataSourceID();

        let listEntities = _.map(
            this.state.colorMapping,
            //                  → let keyArrow = key.split('.').join(' → ');
            (valueList, dsEntityName) => {
                //valueList, entityName
                //LL: 03.12.19: use changed colors
                if (dsEntityName == this.state.entityVal.dsEntityName) {
                    let vList = this.state.entityVal.colorMapping;
                    // here
                }

                let sizeOfColoredValues = _.size(valueList);
                let arrayNames = dsEntityName.split('→');
                let dsName = 'Default';
                let entityName = arrayNames[0];
                let dsID: any = storedDataSourceID;

                let wrongDS = false; //LL: 27.02.25

                if (arrayNames[1] != undefined) {
                    dsID = parseInt(arrayNames[1]);
                    //LL: 27.02.25: not number (outdated format with name)
                    if (isNaN(dsID)) {
                        console.log('EntityColorSelect: dsID not number: ' + arrayNames[1]);
                        wrongDS = true;
                        dsName = arrayNames[1].toString();
                        dsID = arrayNames[1]; //LL: to use in removeButton
                    } else {
                        const dsObj = _.findWhere(dataSources, {
                            dataSourceID: dsID
                        });
                        if (dsObj != null) {
                            dsName = dsObj.name;
                        } else {
                            //LL: 27.02.25
                            console.log('EntityColorSelect: dsID not found: ' + dsID);
                            wrongDS = true;
                            dsName = arrayNames[1].toString();
                        }
                    }
                }

                let asParent = false;

                let parentValue: any; //LL: 09.10.20: try ownKeys
                let parentColors: any; //LL: 10.10.20: parentColors

                for (let k = 0; k < parentValues.length; k++) {
                    const pv = parentValues[k];
                    if (pv.dataSourceID === dsID && pv.attribute === entityName) {
                        if (compareObjects(pv.colorMap, valueList)) {
                            asParent = true;
                        }
                        parentValue = pv; //LL: 09.10.20: try ownKeys
                        parentColors = pv.colorMap; //LL: 10.10.20: parentColors
                        break;
                    }
                }

                //LL: 09.10.20: try ownKeys:    // ~~ ["<no value>", "W20"]
                //let ownKeys = [];
                //let keysArr = _.keys(valueList);  // _.keys({one: 1, two: 2, three: 3}); => ["one", "two", "three"]
                //if (parentValue != null && parentValue.colorMap != null) {
                //    _.each(keysArr, function (obj: any) {
                //        if (parentValue.colorMap[obj] == null || parentValue.colorMap[obj] !== valueList[obj]) {
                //            ownKeys.push(obj);
                //        }
                //    });
                //}
                //else {
                //    ownKeys = keysArr;
                //}

                let removeButton;
                if (!asParent) {
                    removeButton = (
                        <span
                            className="glyphicon glyphicon-remove"
                            onClick={(e) => {
                                this.removeEntityColorButton(e, entityName, dsID);
                            }}
                        ></span>
                    );
                } else {
                    removeButton = (
                        <span className="glyphicon glyphicon-arrow-down" title={'Inherited from parent theme'}></span>
                    );
                }

                //LL: 27.02.25:
                let class_cellDS = 'cell-rows' + (wrongDS ? ' wrongDS' : '');
                let title_cellDS = wrongDS ? 'Wrong Data Source: not found. PLease, remove this Mapping.' : '';

                //LL: 28.02.25:
                let editButton;
                if (!wrongDS) {
                    editButton = (
                        <span
                            className="glyphicon glyphicon-pencil"
                            title={'Edit Color Assignments'}
                            onClick={() => {
                                this.editEntityColorMapButton(entityName, dsID, dsName, parentColors);
                            }}
                        ></span>
                    );
                }

                //LL: 27.02.25: set class cell-rows for 2 last td (was cell-name) - to match with th below
                //LL: 10.10.20: parentColors
                return (
                    <tr key={'entity-map-item-' + dsEntityName}>
                        <td className="cell-remove" style={mouseStyle}>
                            {removeButton}
                        </td>
                        <td className="cell-edit" style={mouseStyle}>
                            {editButton}
                        </td>
                        <td className="cell-name">{entityName}</td>
                        <td className="cell-rows">{sizeOfColoredValues}</td>
                        <td className={class_cellDS} title={title_cellDS}>
                            {dsName}
                        </td>
                    </tr>
                );
            }
        );

        //LL: 20.07.20: note:
        //   I found that entities-table is defined in pdc-widget-entity-model-editor/common.sass
        //LL: 20.07.20: was <table className="table entities-table" >
        //       entities-table  -> entity-color-select

        return (
            <div className="row">
                <div className="col-sm-4">
                    <div className="btn btn-default btn-sm add-entity-button" onClick={this.addEntityColorMapButton}>
                        <span>{'Add Color Lookup Table'}</span>
                    </div>
                </div>
                <table className="table entity-color-select">
                    <thead>
                        <tr>
                            <th className="cell-remove"></th>
                            <th className="cell-edit"></th>
                            <th className="cell-name">{'Entity / Attribute'}</th>
                            <th className="cell-rows">{'No Of Colored Values'}</th>
                            <th className="cell-rows">{'Data Source'}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {empty}
                        {listEntities}
                    </tbody>
                </table>
            </div>
        );
    }
}
